/*jshint esversion: 6 */

import axios from 'axios'
import config from '@/config'
import _get from 'lodash/get'

const tokenHeader = (token) => {
    return {
        'Authorization': `Bearer ${token}`
    }
}

const Client = {
    calculateFare(token, from, to, vin) {
        let path = `${config.runbuggy.api.path}/order/calculateFare`;
        return this.post(path, {
            "pickupAddress": from.address,
            "pickupAddressLatitude": from.lat,
            "pickupAddressLongitude": from.long,
            "destinationAddress":  to.address,
            "destinationAddressLatitude": to.lat,
            "destinationAddressLongitude": to.long,
            "VINCount": 1,
            "nonOperationalVins": [],
            "vinsWithRollingTires": [],
            "vinsWithWorkingBrakes": [],
            "vinsWithFunctionalSteering": [],
            "overSizedVins": [],
            "isTwoWayTrade": false
        }, token);
    },
    get(path, token) {
        return axios.get(path, {
            headers: tokenHeader(token)
        });
    },
    post(path, data, token) {
        return axios.post(path, data, {
            headers: tokenHeader(token)
        });
    },
    getOrderById(id, token, type = '') {
        const path = `${config.workflow.api.path}/${type}orders/${id}`;
        return axios.get(path, {
            headers: tokenHeader(token)
        });
    },
    getRationales(group, token) {
        let path = `${config.workflow.api.path}/rationales`;

        if (group) {
            path = `${path}?group=${group}`;
        }

        return axios.get(path, {
            headers: tokenHeader(token)
        });
    },
    getVehicleTransferOrderById(id, token) {
        let path = `${config.workflow.api.path}/vehicle-transfer-orders/${id}`;
        return axios.get(path, {
            headers: tokenHeader(token)
        });
    },
    getTransportationOrderById(id, token) {
        let path = `${config.workflow.api.path}/transportation-orders/${id}`;
        return axios.get(path, {
            headers: tokenHeader(token)
        });
    }
};

export default Client;
